export default __webpack_public_path__ + "static/media/fpb40200.56c82b2a.png";